// @flow
import React from 'react'
import type { Item } from '../../services/item/types'
import MediaQuery from 'react-responsive'
import Slider from '../sliders/slider'
import TopBar from '../bars/top-bar'
import Indicator from '../texts/indicator'
import InfoText from '../texts/info-text'
//import CtaButton from '../buttons/cta-button'
import Card from '../cards/card'
import { GridRow, GridCol } from '../grid/'
import NormalText from '../texts/normal-text'
import IconButton from '../buttons/icon-button'
import CardGallery from '../cards/card-gallery'
import { domains } from '../../services'
import ScrollHandler from '../../services/search-results/scroll-handler'
import Filters from './filters'

type SearchResultsItemsProps = {
  handleScroll: () => void,
  entities: number[],
  entity: Item,
  id: number,
  handleSliderChange: () => void,
  translations: { results: string },
  itemCountdownText: string
}

const SearchResultsItemsBefore = (props: SearchResultsItemsProps) => {
  const {
    entities,
    entity,
    handleScroll,
    id,
    handleSliderChange,
    translations,
    itemCountdownText,
    isFiltersVisible,
    toggleFilters,
    setFilter,
    currentFilter,
    searchItems,
    clearActiveEntities
  } = props
  if (entities.length === 0) return null
  return (
    <div>
      <TopBar
        leftChildren={
          <NormalText key={1}>{`${entities.length} ${
            translations.results
          }`}</NormalText>
        }
        rightChildren={
          <IconButton
            iconName='filters'
            text='filters'
            key={1}
            onClick={toggleFilters}
          />
        }
      />
      <Filters
        isOpen={isFiltersVisible}
        toggleFilters={toggleFilters}
        setFilter={setFilter}
        currentFilter={currentFilter}
        searchItems={searchItems}
        clearItems={clearActiveEntities}
      />
      <MediaQuery query='(min-width: 1024px)'>
        <ScrollHandler onScroll={handleScroll}>
          <CardGallery cards={entities}>
            <Card domain={domains.ITEMS} />
          </CardGallery>
        </ScrollHandler>
      </MediaQuery>
      <MediaQuery query='(max-width: 1023px)'>
        <Slider
          active={id}
          slides={entities}
          domain={domains.ITEMS}
          afterChange={handleSliderChange}
        >
          <Card domain={domains.ITEMS} />
        </Slider>
        <div className='inner-wrapper'>
          <GridRow>
            <GridCol type='one-half'>
              <Indicator
                isLoud
                labelText='Initial Bid'
                smallText='$'
                titleText={entity.initialBid}
              />
              <Indicator
                labelText='Item Number'
                titleText={entity.itemNumber}
              />
            </GridCol>
            <GridCol type='one-half pull-right'>
              {/*<CtaButton
                text={entity.isSaved ? 'Saved' : 'Save'}
                isActive={entity.isSaved}
                iconName={entity.isSaved ? 'saved' : 'save'}
              />*/}
            </GridCol>
            <InfoText>{itemCountdownText}</InfoText>
          </GridRow>
        </div>
      </MediaQuery>
    </div>
  )
}

SearchResultsItemsBefore.defaultProps = {
  translations: {
    results: 'results'
  }
}

export default SearchResultsItemsBefore



// WEBPACK FOOTER //
// ./src/ui/views/search-results-items-before.js